import { fieldConfig } from "@autoform/zod";
import { z } from "zod";

export const siteEditSchema = z.object({
  enabled: z.boolean().default(true),
  known_venue_id: z
    .string()
    .nullish()
    .superRefine(
      fieldConfig({
        inputProps: { placeholder: "Skip venue resolution for this site" },
      }),
    ),
});

export type SiteEditFormType = z.infer<typeof siteEditSchema>;
